import { load as hypernova } from 'hypernova';
import { type ContextType } from 'hypernova/server';
import { HeaderState } from 'models/HeaderState';
import type { ComponentProps, ComponentType } from 'react';
import { hydrateRoot } from 'react-dom/client';
import Loadable from 'react-loadable';
import initResource from 'utils/resource';
import { Provider, GecpProviders } from '../Providers';

type RequestOptions<
  TState extends HeaderState = HeaderState,
  TReturn = ComponentProps<typeof Provider>
> = ContextType & {
  createProviders(name: string, data: TState, context: ContextType): TReturn;
};

export async function load<T extends HeaderState = HeaderState>(
  name: string,
  Component: ComponentType,
  options: RequestOptions<T>
) {
  const loaded = hypernova<T>(name);
  if (loaded) {
    return Loadable.preloadReady().then(() => {
      loaded.forEach(({ data, node }) => {
        if (!node) {
          return;
        }
        initResource(options.metadata.translations);
        const providers = options.createProviders(name, data, options);
        hydrateRoot(
          node,
          <Provider {...providers}>
            <GecpProviders>
              <Component />
            </GecpProviders>
          </Provider>
        );
      });
      return Component;
    });
  }
  return Component;
}
